import axiosInstance from ".";

export const login = async (payload) => {
    try {
        const getLoginUser = await axiosInstance.get("/user/login", {        
            headers: {
                Authorization: `Basic ${payload}`
            },
        })
        return getLoginUser.data
    } catch (error) {
        console.log("Error in login", error)

        if (error?.isTimeout) {
            return {
                success: false,
                error: "timeout",
                message: error?.message || "Request timed out. Please try again.",
            };
        }

        if (error?.isNetworkError) {
            return {
                success: false,
                error: "network",
                message: error?.message || "Network error. Please check your connection.",
            };
        }

        return {
            success: false,
            message:
                error?.response?.data?.message ||
                error?.message ||
                "Login failed",
            error,
        };
    }
}